export function handleMouseUpByBlurring(event: {
  currentTarget: HTMLOrSVGElement | null;
}): void {
  if(!event) {
    return;
  }
  const { currentTarget } = event;
  currentTarget?.blur();
}
